const Locale = {
  En: 'en' as 'en',
  Ru: 'ru' as 'ru',
  Uk: 'uk' as 'uk',
};

type Locale = typeof Locale[keyof typeof Locale];

export { Locale };
